export { setUserRegionalInfo } from '../src/setUserRegionalInfo';
